import React, { useState } from 'react'
import {
  Input,
  IconCountry,
  Activity
} from '@Knowledge-OTP/znk-ui-components'
import { useSelector } from 'react-redux'
import useTranslation from '../../../../../../i18n/useTranslation'
import moment from 'moment-timezone'

const ProgramProcessInvoice = (props) => {
  const { onProgram = () => { }, loading = false } = props
  const currentTimezone = useSelector((state) => state.user.timezone)
  const [date, setDate] = useState(null)
  const [time, setTime] = useState(null)
  const { translate } = useTranslation()
  const titleLabel = translate('payments.processpayment.programProcessInvoice.title')
  const applyLabel = translate('payments.processpayment.programProcessInvoice.apply')
  return (
    <div className='p-2'>
      <div className='w-100 d-flex flex-column align-items-start'>
        <label className='h4 text-info font-weight-bold'>{titleLabel}</label>
        <Input
          className='w-100 my-4'
          type='date'
          size='small'
          value={date ? moment(date).format('YYYY-MM-DD') : null}
          onChange={(e) => {
            setDate(e.target.value)
          }}
        />
        <Input
          className='m-0 w-100'
          type='time'
          value={time}
          onChange={(e) => {
            const newtime = e.target.value
            const hour = newtime.split(':')[0]
            const minute = newtime.split(':')[1]
            setTime(`${hour}:${minute}`)
          }}
        />
      </div>
      <div className='w-100 d-flex flex-row justify-content-end py-2'>
        <span className='text-gray h45 d-flex flex-row align-items-center'>
          <IconCountry size={12} className='mr-1' />
          {`Current timezone: ${currentTimezone}`}
        </span>
      </div>
      <div className='w-100 d-flex flex-row justify-content-end mt-2'>
        <span
          className='h4 btn-link text-primary d-flex align-items-center'
          onClick={() => {
            if (!date || !time || loading) return
            const hour = time.split(':')[0]
            const minute = time.split(':')[1]
            const processDate = moment(date).tz(currentTimezone).set({ hour: parseInt(hour), minute: parseInt(minute) }).toISOString()
            onProgram(processDate)
          }}
        >
          {loading ? (
            <Activity size={16} />
          ) : (
            applyLabel
          )}
        </span>
      </div>
    </div>
  )
}

export default ProgramProcessInvoice
